package com.anjuros.website.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.anjuros.website.components.changeMode
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.language.UiMode
import com.anjuros.website.components.setMeta
import com.anjuros.website.redesign.components.RdScrollReveal
import com.anjuros.website.redesign.components.SiteFooter
import com.anjuros.website.redesign.components.SiteHeader
import com.anjuros.website.redesign.components.rdNavItems
import com.anjuros.website.redesign.components.setJsonLd
import com.anjuros.website.redesign.sections.pricing.PricingBuilderSection
import com.anjuros.website.redesign.sections.pricing.PricingClosingSection
import com.anjuros.website.redesign.sections.pricing.PricingCompareSection
import com.anjuros.website.redesign.sections.pricing.PricingFaqSection
import com.anjuros.website.redesign.sections.pricing.PricingHeroSection
import com.anjuros.website.redesign.sections.pricing.PricingIncludedSection
import com.anjuros.website.redesign.sections.pricing.pricingStructuredData
import com.anjuros.website.redesign.styles.RdPageStyle
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText
import com.anjuros.website.redesign.util.SITE_URL
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Main

@Page
@Composable
fun WebsiteDesignPricingUk() {
    val title = LocalText(RdText.PRICING_META_TITLE)
    val description = LocalText(RdText.PRICING_META_DESCRIPTION)
    val structuredData = pricingStructuredData()

    LaunchedEffect(Unit) {
        setMeta(title, description, url = "$SITE_URL${RdRoute.PRICING}")
        setJsonLd("ld-pricing", structuredData)
        changeMode(UiMode.NORMAL)
    }

    Div(RdPageStyle.toModifier().toAttrs()) {
        SiteHeader(rdNavItems(currentPath = RdRoute.PRICING))
        Main {
            PricingHeroSection()
            PricingBuilderSection()
            PricingCompareSection()
            PricingIncludedSection()
            PricingFaqSection()
            PricingClosingSection()
        }
        SiteFooter()
        RdScrollReveal()
    }
}
